<template>
  <div>Home dashboard</div>
</template>

<script>
export default {
  name: "Home",
  components: {},
};
</script>
